import { render, staticRenderFns } from "./FormPayWays.vue?vue&type=template&id=7066be20&scoped=true&"
import script from "./FormPayWays.vue?vue&type=script&lang=js&"
export * from "./FormPayWays.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7066be20",
  null
  
)

export default component.exports